<template>
  <el-container class="GoodsForm">
    <el-main class="p-0">
      <ATable 
        :data="items"
        hide-top-panel
        hide-button-insert
        hide-pagination   
        border     
      >
        <el-table-column
          label="품번"
          width="160"
        >
          <template slot-scope="scope">
            <el-input
              size="tiny"           
              v-model="scope.row.code"
              @keydown.enter.native="handleKeydownEnter(scope.row)"
            />     
          </template>
        </el-table-column>
        <el-table-column 
          prop="product_name" 
          label="제품"
          show-overflow-tooltip
        ></el-table-column>
      </ATable> 
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        @click="handleClickRegister"
      >등록</el-button>
      <el-button 
        class="right"
        @click="handleClickClose"
      >{{ $t("button.close") }}(Esc)</el-button>
    </el-footer>
  </el-container>
</template>
<script>

export default {
  name: "GoodsForm",
  data() {
    return {
      title: "품번관리",
      items: [],
    }
  },
  props: {        
    data:  {
      type: Array,
      required: true
    },
  },
  mounted() {
    this.items = this.util.clone(this.data);
  },
  methods: {
    doUpdate(items) {
      let data = this.util.clone(items);
      data.forEach(item => {
        item.code = item.code.trim();
        let code = item.code.substring(item.code.length - 9);
        item.year_flag = code.substring(0, 2);
        item.seq = parseInt(code.substring(2, 6));
        item.month_flag = code.substring(7, 9);
      });
      this.api.updateGood(data).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          this.items.forEach(item => {
            item.code = item.original_code;
          })
          return;
        } else {
          res.data.forEach(d => {
            let index = this.items.findIndex(item => item.id === d.id);
            if (index > -1) {
              d.original_code = d.code;
              this.items.splice(index, 1, d);
            }
          })
          this.util.notify_success(this, this.title, this.$t('message.success_update'));
          this.$emit('updated', this.items)
        }
      })
    },
    handleKeydownEnter(item) {
      if (item.code.trim().length < 9) { return; }
      if (item.code === item.original_code) { return; }
      this.doUpdate([item]);
    },
    handleClickClose() {
      this.$emit('completed');
    },
    handleClickRegister() {
      let items = this.items.filter(item => item.code.trim().length < 9);
      if (items.length > 0) {
        this.util.notify_warning(this, this.title, "형식이 올바르지 않은 품번이 존재합니다.");
        return;
      }
      items = this.items.filter(item => item.code !== item.original_code);
      if (items.length < 1) {
        this.util.notify_warning(this, this.title, "변경된 품번이 없습니다.");
        return;
      }
      //중복 seq 확인
      let codes = this.items.map(item => item.code.substring(item.code.length - 9).substring(2, 6));
      let sorted_codes = Array.from(new Set(codes));
      if (codes.length !== sorted_codes.length) {
        this.util.notify_warning(this, this.title, "중복 품번이 있습니다.");
        return;
      }
      this.doUpdate(items);
    },
  },
}
</script>